import { getCookie } from '@patrianna/shared-utils/cookie'
import cx from 'classnames'

import HorizontalScroll from 'containers/HorizontalScroll'
import slotsClasses from 'src/pageContainers/Home/components/SlotsRow/styles.module.scss'
import { useAppSelector } from 'src/store/hooks'
import { getBannersPriorityLessFifty, getBannersPriorityMoreFifty } from 'src/store/modules/banners/selectors'
import { sweepstakeEnabledSelector } from 'store/modules/appConfig/selectors'
import {
  getUserCommunicationPreferencesSelector,
  getUserPhoneNumberSelector,
  isLoggedInSelector,
} from 'store/modules/user/selectors'
import EXTERNAL_LINKS from 'temp/externalLinks.json'

import Offers from './banners/Offers'
import PromoBannersFromBuilder from './banners/PromoBannersFromBuilder'
import Promotions from './banners/Promotions'
import Rewards from './banners/Rewards'
import SCbanner from './banners/SCbanner'
import SmsConsent from './banners/SmsConsent'
import SocialBanner from './banners/SocialBanner'
import TargetBanners from './banners/TargetBanners'
import WelcomeEmail from './banners/WelcomeEmail'
import classes from './styles.module.scss'

type Props = {
  cookies: string
}

export default function HomeBanners(props: Props) {
  const loggedIn = useAppSelector(isLoggedInSelector)
  const scEnabled = useAppSelector(sweepstakeEnabledSelector)
  const scEnabledFromCookie = Boolean(getCookie('SC_ENABLED', props.cookies))
  const loggedInFromCookie = Boolean(getCookie('LOGGED_IN', props.cookies))
  const visitedFb = getCookie('IS_USER_VISITED_FB', props.cookies)
  const visitedInst = getCookie('IS_USER_VISITED_INSTAGRAM', props.cookies)
  const visitedX = getCookie('IS_USER_VISITED_X', props.cookies)
  const isSCBannerVisible = getCookie('IS_USER_OPENED_SC_RULES', props.cookies)
  const targetBannersMorePriority = useAppSelector(getBannersPriorityMoreFifty)
  const targetBannersLessPriority = useAppSelector(getBannersPriorityLessFifty)
  const communicationPreferences = useAppSelector(getUserCommunicationPreferencesSelector)
  const userPhoneNumber = useAppSelector(getUserPhoneNumberSelector)

  const isScEnabled = scEnabled || scEnabledFromCookie
  const isLoggedIn = loggedIn || loggedInFromCookie
  const showBannersSC = isScEnabled && isLoggedIn
  const isUserPhoneWithoutSmsAndCallConsent =
    !!userPhoneNumber && communicationPreferences.doNotSendSms && communicationPreferences.doNotCall
  const isUserWithoutPhoneAndSmsDisabled = !userPhoneNumber && communicationPreferences.doNotSendSms
  const isSmsConsentBannerVisible =
    (isUserWithoutPhoneAndSmsDisabled || isUserPhoneWithoutSmsAndCallConsent) && isScEnabled && isLoggedIn

  return (
    <HorizontalScroll
      autoScrollTimeInterval={5000}
      scrolledItemDataAttr='data-banner'
      classNameContainer={cx(slotsClasses.root, classes.bannerContainerRoot)}
      gap={8}
    >
      {showBannersSC && !isSCBannerVisible && <SCbanner />}

      <TargetBanners banners={targetBannersMorePriority} />
      <Offers loggedIn={isLoggedIn} scEnabled={isScEnabled} />
      <TargetBanners banners={targetBannersLessPriority} />

      {showBannersSC && <PromoBannersFromBuilder />}

      {showBannersSC && <Promotions />}

      {isSmsConsentBannerVisible && <SmsConsent />}

      <Rewards />
      {!visitedFb && <SocialBanner imgKey='facebook' link={EXTERNAL_LINKS.visitFB} cookie='IS_USER_VISITED_FB' />}
      {!visitedInst && (
        <SocialBanner imgKey='instagram' link={EXTERNAL_LINKS.instagram} cookie='IS_USER_VISITED_INSTAGRAM' />
      )}
      {!visitedX && <SocialBanner imgKey='x' link={EXTERNAL_LINKS.x} cookie='IS_USER_VISITED_X' />}

      <WelcomeEmail />
    </HorizontalScroll>
  )
}
